import { Link } from "react-router-dom";
import { NavItem, NavDropdown } from "./NavbarMenuItems";
import { NavbarMenuItemProps } from "./types";

interface DesktopNavigationProps {
  openDropdown: string | null;
  toggleDropdown: (dropdown: string) => void;
  services: NavbarMenuItemProps[];
  serviceOfferings: NavbarMenuItemProps[];
  valorisations: NavbarMenuItemProps[];
  groupItems: NavbarMenuItemProps[];
  sitesItems: NavbarMenuItemProps[];
  valocapItems: NavbarMenuItemProps[];
}

export const DesktopNavigation = ({
  openDropdown,
  toggleDropdown,
  services,
  serviceOfferings,
  valorisations,
  groupItems,
  sitesItems,
  valocapItems
}: DesktopNavigationProps) => {
  return (
    <div className="hidden md:flex md:items-center md:space-x-6">
      <NavItem name="Accueil" path="/" />
      
      <NavDropdown 
        title="Nos clients"
        isOpen={openDropdown === 'services'}
        toggleDropdown={() => toggleDropdown('services')}
        items={services}
      />
      
      <NavDropdown 
        title="Nos Services"
        isOpen={openDropdown === 'serviceOfferings'}
        toggleDropdown={() => toggleDropdown('serviceOfferings')}
        items={serviceOfferings}
      />
      
      <NavDropdown 
        title="Valorisations"
        isOpen={openDropdown === 'valorisations'}
        toggleDropdown={() => toggleDropdown('valorisations')}
        items={valorisations}
      />

      <NavDropdown 
        title="Notre Groupe"
        isOpen={openDropdown === 'group'}
        toggleDropdown={() => toggleDropdown('group')}
        items={groupItems}
      />
      
      <NavDropdown 
        title="Valocap"
        isOpen={openDropdown === 'valocap'}
        toggleDropdown={() => toggleDropdown('valocap')}
        items={valocapItems}
      />
      
      <NavItem name="Contact" path="/contact" />
    </div>
  );
};
